import React, { Component } from "react";
import PropTypes from "prop-types";
import { TitleDataHeading } from "./styles";

class TitleNode extends Component {
  constructor(props) {
    super(props);
    this.formatTitle = this.formatTitle.bind(this);
  }

  formatTitle(each) {
    return each
      .split(/(?=[A-Z])/)
      .map(name => name.charAt(0).toUpperCase() + name.slice(1))
      .join(" ");
  }

  render() {
    const { title } = this.props;
    return <TitleDataHeading>{this.formatTitle(title)}</TitleDataHeading>;
  }
}

TitleNode.propTypes = {
  title: PropTypes.any
};

export default TitleNode;
